import {Injectable} from '@angular/core';
import {CanActivate} from '@angular/router';
import {Observable, ObservableInput, of, switchMap, take} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AuthService} from '@core/auth/auth.service';
import {User} from '@domain/user/user';

@Injectable({
  providedIn: "root",
})
export class UnvalidatedUserGuard implements CanActivate {
  constructor(private authService: AuthService) {}

  canActivate(): Observable<boolean> {
    return this.authService.refreshAuthenticatedUser().pipe(
      take(1),
      catchError(_err => of(null)),
      switchMap<User | null, ObservableInput<boolean>>(_user => of(true))
    );
  }
}
